function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#A3A3A3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M15.414 21.313v-9.266c0-2.551 2.378-4.62 4.66-4.62 2.284 0 4.417 2.069 4.417 4.62v9.827"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#A3A3A3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M23.699 21.442H.579v-9.278c0-2.551 1.96-4.62 4.377-4.62h14.048"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 4,
  x: 6.434,
  y: 0.554,
  stroke: "#A3A3A3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 0.5
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#A3A3A3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12.5 3v10.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#979797",
  strokeLinecap: "square",
  d: "M10.5 21.5v6m2-6v6"
}));

function SvgInputMailbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputMailbox);
export default __webpack_public_path__ + "static/media/InputMailbox.50d54c43.svg";
export { ForwardRef as ReactComponent };